export const getNextBatchCode = (batch) => {
  if (!Array.isArray(batch) || batch.length === 0) {
    return 1;
  }

  const max = Math.max(...batch);

  for (let i = 1; i <= max; i++) {
    if (!batch.includes(i)) {
      return i;
    }
  }

  return max + 1;
};

export const isBatchCompleted = (batch) => {
  if (!batch.delivery_note_data) {
    return false;
  } else {
    const total = batch.delivery_note_data.filter(
      (x) => x.mash_control === true && x.mash_control_extra === false,
    ).length;
    return total >= batch.min_n_control_mash;
  }
};
